import update from 'external/immutability-helper'
import { useState, useEffect, Button } from 'external/react'

import { authService } from 'services/auth.service'

import useFormValidation, { validators } from 'utilities/form-validation'

import { notifyError, notifySuccess } from 'components/Notify'
import FormTextfield, { PasswordField } from 'components/FormTextfield'
import useAuth from 'context/auth-context/hook'

const  {createEmailValidation, createRequiredFieldValidation, createPasswordMatchValidation, createStrongPaswordValidation} = validators

const resetValidations = { email: [createRequiredFieldValidation('email'), createEmailValidation('email')] }

const changeValidations = {
	code: [createRequiredFieldValidation('code')],
	password: [createRequiredFieldValidation('password'), createStrongPaswordValidation('password')],
	confirmPassword: [createRequiredFieldValidation('confirmPassword'), createPasswordMatchValidation('confirmPassword', 'password')]
}

export default function ResetForm () {

	const {modals, showLogin} = useAuth()

	const [resetState, setResetState] = useState({email: '', codeSent: false})
	const [changeState, setChangeState] = useState({code: '', password: '', confirmPassword: ''})

	const [resetErrors, validateReset] = useFormValidation(resetValidations)
	const [changeErrors, validateChange] = useFormValidation(changeValidations)

	function createFieldProps (placeholder, fieldName, maxLength?) {
		return {
			placeholder,
			maxLength,
			fieldName,
			defaultValue: resetState[fieldName],
			error: resetErrors[fieldName],
			submitted: resetErrors.submitted,
			onChange: (e) => {
				setResetState(update(resetState, {[fieldName]: {$set: e.target.value.trim()}}))
			}
		}
	}

	function createChangeFieldProps (placeholder, fieldName, maxLength?) {
		return {
			placeholder,
			maxLength,
			fieldName,
			error: changeErrors[fieldName],
			submitted: changeErrors.submitted,
			onChange: (e) => {
				setChangeState(update(changeState, {[fieldName]: {$set: e.target.value.trim()}}))
			}
		}
	}

	useEffect(() => { validateReset(resetState, false) }, [resetState])
	useEffect(() => { validateChange(changeState, false) }, [changeState])

	useEffect(() => {setResetState(update(resetState, {email: {$set: modals.reset.email}}))}, [modals.reset])

	async function resetHandler () {
		if (!validateReset(resetState, true)) {
			return
		}
		const response = await authService.resetPassword({email: resetState.email});
		const { statusResponse: {error, message} } = response.data
		if (error) {
			notifyError(message)
		} else {
			notifySuccess(message)
			setResetState(update(resetState, {codeSent: {$set: true}}))
		}
	}

	async function changePasswordHandler () {
		if (!validateChange(changeState, true)) {
			return
		}
		const response = await authService.changePassword({email: resetState.email, code: changeState.code, password: changeState.password});
		const { success, message } = response.data
		if (success) {
			notifySuccess(message)
			showLogin()
		} else {
			notifyError(message)
		}

	}
	

	return (
		<form autoComplete='on'>
			{!resetState.codeSent && (
				<>
				<FormTextfield {...createFieldProps('Correo', 'email')} />
				<div className='actions_reset mt-3'>
					<Button variant='primary' onClick={resetHandler}>
						Enviar código
					</Button>
				</div>
				</>
			)}
			{resetState.codeSent && (
				<>
				<FormTextfield {...createChangeFieldProps('Código', 'code')} />
				<PasswordField {...createChangeFieldProps('Contraseña', 'password')} />
				<PasswordField {...createChangeFieldProps('Confirmar contraseña', 'confirmPassword')} />
				<div className='actions_login mt-3'>
					<Button variant='primary' onClick={changePasswordHandler}>
						Cambiar contraseña
					</Button>
					<Button variant='secondary' onClick={() => setResetState(update(resetState, {codeSent: {$set: false}}))}>
						Reenviar código
					</Button>

					<Button variant='light' onClick={() => showLogin()}>
						Iniciar Sesion
					</Button>
				</div>
				</>
			)}

		</form>
	)
}
